import type { SVGProps } from 'react';

const SvgCollectionOpened = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M17.08 20.005H6c-1.65 0-3-1.35-3-3v-10c0-1.65 1.35-3 3-3h3c1.3 0 2.23.62 3.05 1.17.67.45 1.25.83 1.95.83h4c1.65 0 3 1.35 3 3v2c0 .1-.02.2-.04.29.62.29 1.12.8 1.42 1.45.5 1.08.32 2.31-.45 3.21l-2.57 3c-.57.67-1.4 1.05-2.28 1.05m-11.93-2.48c.18.29.49.48.85.48h11.08c.29 0 .57-.13.76-.35l2.57-3c.39-.45.21-.93.15-1.07a.97.97 0 0 0-.91-.58H9.01a1 1 0 0 0-.8.4zM6 6.005c-.55 0-1 .45-1 1v7.37l1.6-2.15c.56-.76 1.46-1.21 2.41-1.21H19v-2c0-.55-.45-1-1-1h-4c-1.3 0-2.23-.62-3.05-1.17-.67-.45-1.25-.83-1.95-.83H6z"
    />
  </svg>
);
export default SvgCollectionOpened;
